import { cleanFractions } from './clean-department-fractions'
import { cleanEntityTaxes } from './clean-entity-taxes'
import { cleanEntityPrinting } from './clean-entity-printing'
import { cleanModifiers } from './clean-department-modifiers'
import { cleanDepartmentCategory } from './clean-department-category'
import { cleanDepartmentItem } from './clean-department-item'
import { cleanEntityKps } from './clean-entity-kps'
import { cleanOnlineCategories } from './clean-online-categories'

export function cleanDepartment (department, menuBlob, forPublish = false) {
  cleanFractions(department)
  cleanEntityTaxes(department, menuBlob)
  cleanEntityPrinting(department, department, menuBlob)
  cleanEntityKps(department, department, menuBlob)
  cleanModifiers(department, menuBlob, forPublish)

  for (let category of department.categories) {
    cleanDepartmentCategory(category, department, menuBlob, forPublish)
  }

  for (let item of department.items) {
    cleanDepartmentItem(item, department, menuBlob, forPublish)
  }

  cleanOnlineCategories(menuBlob.onlineCategories)
}
